var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "viewer"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "nav-next",
    on: {
      "click": function($event) {
        _vm.selectNext()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-previous",
    on: {
      "click": function($event) {
        _vm.selectPrev()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toggle",
    on: {
      "click": _vm.toggle
    }
  })]), _vm._v(" "), (_vm.img) ? _c('div', {
    staticClass: "slide active"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v(_vm._s(_vm.img.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.img.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: "url(" + _vm.img.imgix_url + ")",
      backgroundSize: "contain",
      backgroundPosition: "center"
    })
  })]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-983a84e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gallery/Viewer.vue
// module id = KzMV
// module chunks = 0